export default "__VITE_ASSET__BNwCzSFy__"